import { pipelineId, pipelineSchemaLibraryId, schemaLibraryVersionId } from '../fixture-ids';

const pipelineSchemaLibraryParentRefs = [{ key: 'pipelineId', entity: 'pipeline' }];

export const pipelineSchemaLibraryEntries = {
  // pipeline_schema_libraries has its own id column, so identity uses idKeys, not compositeIdKeys.
  // parentRefs is declared anyway so these rows show in the pipeline's own audit view.
  SCHEMA_LIBRARY_ADDED_TO_PIPELINE: {
    entity: 'pipelineSchemaLibrary',
    identity: 'record',
    idKeys: ['id'],
    renderMode: 'diff',
    createsRecord: true,
    parentRefs: pipelineSchemaLibraryParentRefs,
    foreignDisplayKeys: ['schemaLibraryName', 'pipelineName'],
  },
  SCHEMA_LIBRARY_REMOVED_FROM_PIPELINE: {
    entity: 'pipelineSchemaLibrary',
    identity: 'record',
    idKeys: ['id'],
    renderMode: 'diff',
    createsRecord: false,
    parentRefs: pipelineSchemaLibraryParentRefs,
    foreignDisplayKeys: ['schemaLibraryName', 'pipelineName'],
  },
};

const pipelineSchemaLibraryDebugData = {
  schemaLibraryVersionId,
  schemaLibraryName: 'Core Events',
  pipelineId,
  pipelineName: 'Web Analytics',
};

export const pipelineSchemaLibraryFixtures = {
  SCHEMA_LIBRARY_ADDED_TO_PIPELINE: {
    action: 'SCHEMA_LIBRARY_ADDED_TO_PIPELINE',
    debugData: { id: pipelineSchemaLibraryId, ...pipelineSchemaLibraryDebugData },
  },
  SCHEMA_LIBRARY_REMOVED_FROM_PIPELINE: {
    action: 'SCHEMA_LIBRARY_REMOVED_FROM_PIPELINE',
    debugData: { id: pipelineSchemaLibraryId, ...pipelineSchemaLibraryDebugData },
  },
};
